(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
if (!customElements.get('uv-category-scroll')) {
  customElements.define('uv-category-scroll', class extends HTMLElement {
    connectedCallback() {
      this.list = this.parentElement.querySelector('.uv-category-bar__links');
      this.thumb = this.querySelector('span');
      if (!this.list || !this.thumb) return;
      this.update = () => {
        const max = this.list.scrollWidth - this.list.clientWidth;
        this.hidden = max <= 1;
        if (this.hidden) return;
        const width = Math.max(12, this.clientWidth * this.list.clientWidth / this.list.scrollWidth);
        const position = Math.min(1, Math.max(0, Math.abs(this.list.scrollLeft) / max));
        this.thumb.style.width = width + 'px';
        this.thumb.style.transform = 'translateX(' + position * (this.clientWidth - width) + 'px)';
      };
      this.list.addEventListener('scroll', this.update, { passive: true });
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.list);
      Array.from(this.list.children).forEach(item => this.observer.observe(item));
      this.update();
    }
    disconnectedCallback() {
      this.list?.removeEventListener('scroll', this.update);
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
